import * as _ from 'lodash';
import { fromJS } from 'immutable';
import * as recalculateActions from '../actions/recalculation';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';

const initialState = {
  allJobs: {
    data: [],
    state: null,
  },
  marketAreaCodes: {
    data: [],
    state: null,
  },
  jobErrors: {
    data: [],
    totalRecords: 0,
    state: null,
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case recalculateActions.FETCH_ALL_JOBS[START]: {
      return state.setIn(['allJobs', 'state'], fetchingState.FETCHING);
    }
    case recalculateActions.FETCH_ALL_JOBS[ERROR]: {
      return state.setIn(['allJobs', 'state'], fetchingState.ERROR);
    }
    case recalculateActions.FETCH_ALL_JOBS[SUCCESS]: {
      return state
        .setIn(['allJobs', 'state'], fetchingState.LOADED)
        .setIn(
          ['allJobs', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case recalculateActions.CREATE_JOB[SUCCESS]: {
      return state.setIn(
        ['allJobs', 'data'],
        fromJS([
          ..._.get(action, ['data', 'results'], []),
          ...state.getIn(['allJobs', 'data']).toJS(),
        ]),
      );
    }

    case recalculateActions.FETCH_MARKET_AREA_CODES[START]: {
      return state.setIn(['marketAreaCodes', 'state'], fetchingState.FETCHING);
    }
    case recalculateActions.FETCH_MARKET_AREA_CODES[ERROR]: {
      return state.setIn(['marketAreaCodes', 'state'], fetchingState.ERROR);
    }
    case recalculateActions.FETCH_MARKET_AREA_CODES[SUCCESS]: {
      return state
        .setIn(['marketAreaCodes', 'state'], fetchingState.LOADED)
        .setIn(
          ['marketAreaCodes', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case recalculateActions.FETCH_RECALC_JOB_ERRORS[START]: {
      return state.setIn(['jobErrors', 'state'], fetchingState.FETCHING)
    }
    case recalculateActions.FETCH_RECALC_JOB_ERRORS[ERROR]: {
      return state.setIn(['jobErrors', 'state'], fetchingState.ERROR);
    }
    case recalculateActions.FETCH_RECALC_JOB_ERRORS[SUCCESS]: {
      return state
        .setIn(['jobErrors', 'state'], fetchingState.LOADED)
        .setIn(
          ['jobErrors', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        )
        .setIn(
          ['jobErrors', 'totalRecords'],
          _.get(action, 'data.errorCount', 0),
        );
    }

    default:
      return state;
  }
};
